module.exports = __webpack_public_path__ + "static/media/skopei-s.96b2b710.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/skopei-s.svg
// module id = 578
// module chunks = 14